var url = "340a39dfbe0420ca6c2fb1e2857c1a24.gif";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;